import moment from "moment";
import { RecordingSource } from "./recording-source";
import { Recording } from "./recording";

export class RecordingJobBase {
  constructor(
    public id: string,
    public name: string,
  ) {}
}

export class RecordingJob extends RecordingJobBase {
  constructor(
    id: string,
    name: string,
    public startTime: moment.Moment,
    public endTime: moment.Moment,
    public jobStatus: RecordingJobStatus,
    public videoQuality: RecordingVideoQuality,
    public audioQuality: RecordingAudioQuality,
    public recordingSources: Array<RecordingSource>,
    public recordings: Array<Recording> = [],
  ) {
    super(id, name);
  }
  public isRunning(): boolean {
    return this.jobStatus === RecordingJobStatus.Running;
  }
  public fixStatusBeforeUpdatingServer(): void {
    /*const now = moment.utc();
        if (this.jobStatus === RecordingJobStatus.Scheduled
            && this.startTime.isBefore(now)
            && this.endTime.isAfter(now)) {
                this.jobStatus = RecordingJobStatus.Running;
        }*/
  }
}

export enum RecordingJobStatus {
  Scheduled = 0,
  Running,
  Stopped,
  Finished,
}

export enum RecordingAudioQuality {
  Low,
  High,
}
export enum RecordingVideoQuality {
  Low,
  High,
}
